import { styled } from 'styled-components';

import { typography } from '@/styles/helpers';

export const ScLockedGameCardInner = styled.div`
  container-type: inline-size;
  container-name: locked-game-card;
  width: 100%;
  aspect-ratio: 1 / 1;
  gap: 12px;
  border-radius: 12px;
  position: relative;
  z-index: 1;
  overflow: hidden;

  & .content {
    position: absolute;
    inset: 0;
    z-index: 3;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.8) 0%,
      rgba(0, 0, 0, 0.8) 100%
    );
    padding: 0px 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const ScLockedGameCardIcon = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 360px;
  background: rgba(255, 255, 255, 0.2);

  img {
    transform: scale(1);
  }

  @container locked-game-card (min-width: 141px) {
    width: 48px;
    height: 48px;

    img {
      transform: scale(1.5);
    }
  }
`;

export const ScLockedGameCardMessage = styled.p`
  ${typography['body2bold']};
  line-height: 20px;
  letter-spacing: 0.14px;
  color: ${({ theme }) => theme.whiteColor};
  text-align: center;

  & strong {
    color: ${({ theme }) => theme.secondaryColor};
  }
`;
